import { createFileRoute, useNavigate, redirect } from "@tanstack/react-router";
import { PolicyForm } from "@/features/insurance/PolicyForm";
import { canCreateInsurancePolicy } from "@/lib/roles";
import { currentUserQueryOptions } from "@/hooks/useCurrentUser";

export const Route = createFileRoute("/_authenticated/insurance/new")({
  beforeLoad: async ({ context }) => {
    const me = await context.queryClient.ensureQueryData(currentUserQueryOptions());
    if (!canCreateInsurancePolicy(me.roles)) throw redirect({ to: "/insurance" });
  },
  component: NewPolicyPage,
});

function NewPolicyPage() {
  const navigate = useNavigate();
  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-semibold">New Insurance Policy</h1>
      <PolicyForm onSaved={(p) => navigate({ to: "/insurance/$policyId", params: { policyId: p.id } })} />
    </div>
  );
}
